<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OcPK6L/tc-custom/9781466806061.jpg?1737748006795" alt="This image is the cover for the book The Stone Virgins"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Stone Virgins
      </h1>
      <p class="bookDescription body article font2">
        <b>An uncompromising novel by one of Africa’s premiere writers, detailing the horrors of civil war in luminous, haunting prose.</b><br/><br/><b>Winner of the Macmillan Prize for African Adult Fiction</b><br/><br/>In 1980, after decades of guerilla war against colonial rule, Rhodesia earned its hard-fought-for independence from Britain. Less than two years thereafter when Mugabe rose to power in the new Zimbabwe, it signaled the beginning of brutal civil unrest that would last nearly a half decade more.<br/><br/>With <i>The Stone Virgins</i>, Yvonne Vera examines the dissident movement from the perspective of two sisters living in a small township outside of Bulawayo. In a portrait painted in successive impressions of life before and after the liberation, Vera explores the quest for dignity and a centered existence against a backdrop of unimaginable violence; the twin instincts of survival and love; the rival pulls of township and city life; and mankind’s capacity for terror, beauty, and sacrifice. One sister will find a reason for hope. One will not make it through alive.<br/><br/>Weaving historical fact within a story of grand passions and striking endurance, Vera has gifted us with a powerful and provocative testament to the resilience of the Zimbabwean people.<br/><br/><b>“Yvonne Vera writes with magnificent luminosity. <i>The Stone Virgins</i> is a song about the author’s people, and the tragedy of their lives and their loves, contrasted against the sheer beauty of their land. It may yet prove to be one of the notable novels of the twenty-first century.” —Ama Ata Aidoo, award-winning author of <i>Changes: A Love Story</i></b><br/><br/><b>“Without sensationalism or heroics, this searing novel speaks of dislocation, terror, betrayal, and strength.” —<i>Booklist</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Yvonne Vera
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7e73724a